import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const REVIEW_PRICE = 350;
const WARRANTY_HOURS = 168;
const CHAIN_PRICE = 24;
const CHAIN_ACTION_PRICE = 3.5;

const TWOGIS_FAQ = [
  {
    title: 'Что такое Boostclick и как работает сервис?',
    isH3: true,
    text: (
      <p>
        <b>Boostclick</b> — это платформа, где можно разместить задание для получения обратной связи от реальных пользователей.
        <br />
        <br />
        Вы описываете, что именно нужно протестировать (услугу, контакты, визуальное оформление компании и т.п.), а исполнители выполняют задание удалённо через приложение или сайт 2ГИС и оставляют отзыв, основанный на личном опыте.
        <br />
        <br />
        Платформа не размещает отзывы от вашего имени и не гарантирует положительные оценки.
      </p>
    ),
  },
  {
    title: 'Как проходит удалённое тестирование?',
    isH3: true,
    text: (
      <div>
        Исполнитель получает задание и:
        <br />
        <br />
        <ol>
          <li>Открывает 2ГИС и находит карточку вашей компании;</li>
          <li>Просматривает фотографии, отзывы, меню или список услуг;</li>
          <li>Строит маршрут или сохраняет место в избранное;</li>
          <li>Оценивает удобство карточки и качество информации;</li>
          <li>Пишет отзыв, основываясь на реальном взаимодействии.</li>
        </ol>
      </div>
    ),
  },
  {
    title: 'Зачем продвигаться в 2ГИС?',
    isH3: true,
    text: (
      <p>
        2ГИС — один из ведущих картографических сервисов в России и СНГ.
        <br />
        Активность на карточке компании (построение маршрутов, просмотры фото, сохранение в избранное) влияет на видимость вашей организации в поиске 2ГИС.
        <br />
        <br />
        Реальные отзывы повышают доверие и помогают выделиться среди конкурентов.
      </p>
    ),
  },
  {
    title: 'Какие гарантии предоставляет Boostclick?',
    isH3: false,
    text: (
      <ul>
        <li>Задание выполняется реальным пользователем вручную;</li>
        <li>У вас есть 72 часа на проверку результата;</li>
        <li>Если отчёт не соответствует условиям, можно запросить замену;</li>
        <li>Boostclick не влияет на модерацию 2ГИС и не гарантирует размещение отзыва.</li>
      </ul>
    ),
  },
  {
    title: 'Сколько времени занимает размещение отзыва?',
    isH3: false,
    text: (
      <ul>
        <li>Исполнитель выполняет задание в течение 24 часов;</li>
        <li>После публикации отзыв проходит модерацию 2ГИС;</li>
        <li>Весь процесс занимает от 2 до 5 дней.</li>
      </ul>
    ),
  },
  {
    title: 'Вы работаете с юридическими лицами?',
    isH3: false,
    text: (
      <p>
        Да. Предоставляем акты, счета и закрывающие документы через ЭДО.
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя. Каждый
    сценарий начинается с поиска организации в 2ГИС.
  </p>
);

const ACTIONS = [
  {
    type: 'MAIN.REVIEW',
    icon: 'message',
    iconHome: 'home-reviews',
    title: 'Написать отзыв об организации',
    titleComment: '(полное тестирование вашей услуги)',
    initialShare: 0,
    price: `от ${REVIEW_PRICE}`,
    itemTitle: 'тест+отзыв',
    activityType: 'Отзыв',
  },

  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть 2ГИС', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Найти организацию', initialShare: 1 },

  {
    type: 'EXTRA.FEEDBACKS',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Прочитать отзывы об организации',
    initialShare: 0.3,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Отзывы',
  },

  {
    type: 'MAIN.PHOTOS',
    icon: 'eye',
    iconHome: 'home-eye',
    title: 'Просмотреть фотографии',
    initialShare: 0.5,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Фото',
  },
  {
    type: 'MAIN.MENU',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Посмотреть меню или список услуг',
    initialShare: 0.3,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Меню',
  },
  {
    type: 'MAIN.SAVE',
    icon: 'heart',
    iconHome: 'home-heart',
    title: 'Сохранить место в избранное',
    initialShare: 0.3,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Избранное',
  },
  {
    type: 'MAIN.ROUTE',
    icon: 'click',
    iconHome: 'home-click',
    title: 'Построить маршрут до организации',
    initialShare: 0,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Маршрут',
  },
  {
    type: 'MAIN.SHARE',
    icon: 'repost',
    iconHome: 'home-repost',
    title: 'Поделиться карточкой организации',
    initialShare: 0,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Поделиться',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: 'home-action',
    title: 'Поведенческая активность',
    path: '/povedencheskie-faktory-na-2gis',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: 'home-reviews',
    title: 'Оставить отзыв',
    path: '/reviews-on-2gis',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: 'home-click',
    title: 'Построить маршрут',
    path: '/povedencheskie-faktory-na-2gis',
    target: '_self',
  },
  {
    iconHome: 'home-eye',
    title: 'Просмотреть фото',
    path: '/povedencheskie-faktory-na-2gis',
    target: '_self',
  },
  {
    iconHome: 'home-glasses',
    title: 'Меню / услуги',
    path: '/povedencheskie-faktory-na-2gis',
    target: '_self',
  },
  {
    iconHome: 'home-heart',
    title: 'Сохранить в избранное',
    path: '/povedencheskie-faktory-na-2gis',
    target: '_self',
  },
  {
    iconHome: 'home-magic',
    title: 'Генерация отзыва от GPT',
    path: 'https://ai.boostclick.ru/',
    target: '_blank',
    isGPT: true,
  },
];

const LIST_ONLINE_SERVICES = [
  { title: 'Своя услуга' },
  {
    title: 'Консультация по телефону',
    text: 'Тестировщик звонит и оценивает качество обслуживания',
  },
  {
    title: 'Онлайн-консультация',
    text: 'Тестировщик обращается через сайт или мессенджер',
  },
  {
    title: 'Оценка карточки компании',
    text: 'Тестировщик изучает карточку в 2ГИС и оставляет впечатление',
  },
  {
    title: 'Оценка меню / прайса',
    text: 'Тестировщик изучает меню или услуги по фото и описанию',
  },
  { title: 'Другое (укажите свою услугу)' },
];

const STEP_PHRASE_2 = 'Укажите информацию для поиска организации в 2ГИС';

const TWOGIS_KEYWORDS = [
  '2ГИС', '2gis', '2GIS', 'ДубльГИС', 'Дубль ГИС',
];

class TwoGisClass extends Market {

  id = 'TwoGis';
  host = '2gis.ru';
  hostsList = [
    '2gis.ru',
    '2gis.com',
    '2gis.kz',
    '2gis.kg',
    '2gis.ua',
    '2gis.ae',
  ];
  url = 'https://2gis.ru/';

  title = '2ГИС';

  isMarketplace = false;
  isMaps = true;

  icon = 'twogis';
  titlePlaces = '2ГИС*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];
  chainsPerDayNormal = 200 / 30;

  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;


  chainsStep = 1;
  viewsStep = 10;

  keywords = TWOGIS_KEYWORDS;

  targetLinkComment = 'Укажите тут ссылку вашей компании в 2ГИС';
  targetLinkCommentShort = 'Укажите ссылку компании';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      marketKey: 'twogis:chains',
      path: '/povedencheskie-faktory-na-2gis',
      rating: 0.968,
      title: 'ПФ 2ГИС',
      navigateTitle: 'ПФ действия на карточке компании в 2ГИС',
      icon: 'lightning',
      iconForHomePage: 'home-action',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ на 2ГИС — от ${CHAIN_PRICE} руб. | Boostclick`,
        description: `Продвижение компании в 2ГИС через поведенческие факторы от ${CHAIN_PRICE} руб. — маршруты, фото, избранное.`,
        canonical: '/povedencheskie-faktory-na-2gis',
      },
      intro: {
        title: 'Продвижение через ПФ в 2ГИС',
        comment: 'Через выполнение микрозадач от реальных пользователей',
        points: [
          'Увеличит просмотры и активность на карточке',
          'Улучшит позиции в поиске 2ГИС',
          'Маршруты, просмотры фото, сохранение в избранное',
          'Только реальные пользователи без ботов',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте стоимость ПФ на 2ГИС и параметры',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать ПФ на 2ГИС',
      titleFAQ: 'Вопрос-ответ по накрутке ПФ на 2ГИС',
      faq: TWOGIS_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Каждый исполнитель получит индивидуальное задание, начиная с поиска организации в 2ГИС.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
      ],
    },
    {
      id: MARKET_MODES.REVIEWS,
      marketKey: 'twogis:reviews',
      path: '/reviews-on-2gis',
      rating: 0.969,
      title: 'Отзывы',
      navigateTitle: 'Отзывы от пользователей на 2ГИС',
      icon: 'message',
      iconForHomePage: 'home-reviews',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Отзывы на 2ГИС от ${REVIEW_PRICE} руб. — заказать от ЛЮДЕЙ | Boostclick`,
        description: `Отзывы ЛЮДИ на 2ГИС — закажите через Boostclick. Реальные пользователи, оплата после результата.`,
        canonical: '/reviews-on-2gis',
      },
      intro: {
        title: 'Получить обратную связь на 2ГИС',
        comment: 'Тестирование вашей компании или услуги реальными пользователями',
        points: [
          'Отзывы от независимых пользователей после взаимодействия с компанией',
          'Гарантия выполнения задания исполнителем',
          'Электронный чек после оплаты',
          `Оплата только после выполнения (до ${WARRANTY_HOURS} часов)`,
          'Подходит для любых сфер и регионов',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры задания на 2ГИС',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Получение обратной связи о вашем бизнесе от реальных пользователей',
      titleFAQ: 'Частые вопросы о получении обратной связи на 2ГИС',
      faq: TWOGIS_FAQ,
      listOnlineServices: LIST_ONLINE_SERVICES,
      actions: (() => {
        const pfWithReview = ['EXTRA.FEEDBACKS', 'MAIN.PHOTOS', 'MAIN.MENU', 'MAIN.SAVE'];
        return [
          ...ACTIONS
            .filter(action => action.type === 'MAIN.REVIEW')
            .map(action => ({ ...action, initialShare: 1 })),
          ...ACTIONS
            .filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.'))
            .map(action => pfWithReview.includes(action.type) ? { ...action, initialShare: 1 } : action),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
        'Оплата — только после подтверждения результата.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку вашей компании в 2ГИС';
  invalidUrlStr = 'Укажите корректную ссылку на компанию в 2ГИС';
}

const TwoGis = new TwoGisClass();
export default TwoGis;
